// client/components/x-buildify-drawer-wrapper.ts
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-flex.js";
import { DesignSystem } from "@adornis/chemistry/elements/theming/design.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import "@adornis/fonts/fonts.js";
import { html, nothing } from "lit";
import "./x-icon-button.js";
function drawerWrapper({
  content,
  cancel,
  validate,
  deleteEntity,
  title,
  options
}) {
  const spacing = DesignSystem.currentTheme.value.spacing;
  const colors = DesignSystem.currentTheme.value.colors;
  return xComponents(html`
    <x-flex padding="md" space="lg" ${css({ width: "min(600px, 100vw)", height: "100%" })}>
      <x-flex space="lg" flex>
        <x-h4> ${title} </x-h4>
        <x-flex space="md"> ${content()} </x-flex>
      </x-flex>
      <x-flex space="sm" horizontal space-between crossaxis-center ${css({ paddingTop: spacing.sm })}>
        <x-text ${css({ color: "#333", cursor: "pointer" })} @click=${() => cancel()}> abbrechen </x-text>
        <x-flex horizontal crossaxis-center space="sm">
          ${deleteEntity ? html`
                <x-icon-button
                  icon="delete"
                  color="#fff"
                  background=${colors.tone.error}
                  text="Löschen"
                  @click=${async () => deleteEntity()}
                ></x-icon-button>
              ` : nothing}
          <x-icon-button
            icon=${options?.saveIcon ? options.saveIcon : "save"}
            background=${colors.accent}
            color=${colors.on.accent}
            text="Speichern"
            @click=${() => validate()}
          ></x-icon-button>
        </x-flex>
      </x-flex>
    </x-flex>
  `);
}
export {
  drawerWrapper
};
